
import { useParams } from 'react-router-dom';
import { TallesFormState } from '../../../context/talles/TallesFormState';
import { Form } from './form';

export const TallesFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Talle":"Crear Talle";
  
  return (
    <TallesFormState>
        <br />
        <Form title={title} />
    </TallesFormState>
  );
};
